import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { alpha, useTheme } from '@mui/material/styles';
import Container from '../../Container';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { toggleSidebar } from '../../../redux/slices/uiSlice';
import LogoutButton from './components/LogoutButton';

const Topbar = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useAppSelector(state => state.user);

  const toggleSidebarHandler = () => {
    dispatch(toggleSidebar());
  };

  return (
    <Container paddingY={1}>
      <Box display='flex' justifyContent='space-between' alignItems='center' width={1}>
        <Box
          display='flex'
          component='a'
          href='/'
          title='Ficohsa Seguros'
          sx={{
            textDecoration: 'none',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            sx={{
              height: 40,
              width: 40,
              backgroundColor: 'white',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '1.25rem',
              color: theme.palette.primary.main,
            }}
          >
            F
          </Box>
          <Box
            component='span'
            sx={{
              color: 'white',
              fontWeight: 700,
              fontSize: '1.25rem',
              display: { xs: 'none', sm: 'block' },
            }}
          >
            Ficohsa Seguros
          </Box>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'flex' } }} alignItems='center'>
          {isLoggedIn && (
            <Box marginLeft={2}>
              <LogoutButton header />
            </Box>
          )}
        </Box>
        <Box sx={{ display: { xs: 'block', md: 'none' } }} alignItems='center'>
          <IconButton
            onClick={toggleSidebarHandler}
            aria-label='Menu'
            sx={{
              borderRadius: 2,
              minWidth: 'auto',
              padding: 1,
              borderColor: alpha(theme.palette.divider, 0.2),
              color: 'white',
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Box>
    </Container>
  );
};

export default Topbar;
